import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { AgrPageModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { LabresultComponent as LabResultComponent } from './labresult.component';

import { SharedModule } from '../shared/shared.module';
import { LabresultEffects } from './store/effects/labresult.effects';

import { labresultReducer } from './store/reducers/labresult.reducer';

@NgModule({
  declarations: [LabResultComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSortModule,
    MatCardModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatIconModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule,
    MatSelectModule,
    MatTreeModule,
    MatSlideToggleModule,
    AgrPageModule,
    AgrFormModule,
    AgrPrimaryActionModule,
  ],
  providers: [
    provideState('labresultModule', labresultReducer),
    provideEffects([LabresultEffects]),
  ],
  exports: [],
})
export class LabresultModule {}
